import * as React from "react";
import { ChartRefContext } from "../context/ChartRefs";
import { ChartDataContext } from "../context/Chart";
import { Spinner } from "./Spinner";
import axios from "axios";

export type ExcelDownloadButtonProps = {
    nonce: string;
    ajaxUrl:string;
}

type Postdata = {
    nonce: string;
}

export const ExcelDownloadButton = (props: ExcelDownloadButtonProps) => {

    const [excelUri, setExcelUri] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);

    const generateExcel = () => {
        const postdata: Postdata = {
            nonce: props.nonce
        };

        setLoading(true);

        axios
            .post(
                props.ajaxUrl + '?action=zmpzt_research_scan_get_stats_xls',
                postdata,
            )
            .then((res): void => {
                setExcelUri(res.data.url);
                setLoading(false);
            });
    }

    const downloadExcel = () => {
        window.open(excelUri, '_blank');
        setExcelUri('');
    }

    return <>
        {excelUri === '' ?
            (!loading ? <button className={'c-segments__download-pdf'} onClick={generateExcel}>Excel met alle data
                genereren</button> : <Spinner title={'Bezig met het genereren van de Excel'} />) :
            (<button className={'c-segments__download-pdf'} onClick={downloadExcel}>Excel downloaden</button>)}
    </>
}
